import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HotlineProDetailViewLayoutSkeleton } from '@/feature/hotline/professional/detail/component/HotlineProDetailViewLayout';
import { HotlineProBeforeMeetingContentSkeleton } from '@/feature/hotline/professional/detail/meeting/component/HotlineProBeforeMeetingContent';
import { hotlineProDetailMeetingViewStyle } from '@/feature/hotline/professional/detail/meeting/page/style';
/**
 * 匿名ホットライン 面談実施ページ（スケルトン）
 */
export const HotlineProDetailMeetingViewSkeleton = () => {
    const style = hotlineProDetailMeetingViewStyle();
    return (_jsx(HotlineProDetailViewLayoutSkeleton, { children: _jsx("div", Object.assign({ className: style.content() }, { children: _jsx(HotlineProBeforeMeetingContentSkeleton, {}) })) }));
};
